import {
	__experimentalUnitControl as UnitControl,
	ToggleControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import metadata from '../../block.json';

export default function PaginationControls( { attributes, setAttributes } ) {
	const handleChange = ( key, value ) => {
		setAttributes( {
			pagination: {
				...attributes.pagination,
				[ key ]: value,
			},
		} );
	};

	return (
		<>
			<ToggleControl
				__nextHasNoMarginBottom
				label={ __( 'Show pagination', 'brandy-blocks' ) }
				checked={ attributes.pagination?.enabled ?? true }
				onChange={ ( v ) => handleChange( 'enabled', v ) }
			/>
			{ ( attributes.pagination?.enabled ?? true ) && (
				<>
					<UnitControl
						label={ __(
							'Pagination dot size',
							'brandy-blocks'
						) }
						onChange={ ( v ) => handleChange( 'size', v ) }
						value={
							attributes.pagination?.size ??
							metadata.attributes.pagination.default.size
						}
						units={ [
							{ value: 'px', label: 'px', default: 12 },
						] }
					/>
					<UnitControl
						label={ __(
							'Pagination dot spacing',
							'brandy-blocks'
						) }
						onChange={ ( v ) => handleChange( 'spacing', v ) }
						value={
							attributes.pagination?.spacing ??
							metadata.attributes.pagination.default.spacing
						}
						units={ [
							{ value: 'px', label: 'px', default: 12 },
						] }
					/>
				</>
			) }
		</>
	);
}
